import { render, staticRenderFns } from "./account_type.vue?vue&type=template&id=47f35143&scoped=true"
import script from "./account_type.vue?vue&type=script&lang=js"
export * from "./account_type.vue?vue&type=script&lang=js"
import style0 from "./account_type.vue?vue&type=style&index=0&id=47f35143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f35143",
  null
  
)

export default component.exports